import { getLocales } from 'expo-localization';
import AsyncStoragePlugin from 'i18next-react-native-async-storage';

const languageDetector: Parameters<typeof AsyncStoragePlugin>['0'] = (callback) => {
	const { languageCode, languageTag } = getLocales()[0];
	const detectedLanguageCode = languageCode ?? languageTag.split('-')[0];

	return callback(detectedLanguageCode);
};

const LanguageDetector = AsyncStoragePlugin(languageDetector);

export { LanguageDetector };
